import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Spinner,
  CardImg
} from 'reactstrap';
import { RiAddCircleLine, RiDeleteBinLine } from 'react-icons/ri';
import axios from 'axios';
import ApiClient from "../../api-client";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
const AddCategoryModal = ({ isOpen, toggle, fetchCategories, categoryId, categoryName, setCategoryName, categoryDescription, setCategoryDescription, videoLinks, setVideoLinks, categoryImages, setCategoryImages, categoryIcon, setCategoryIcon }) => {

  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [categoryPrevImage, setCategoryPrevImage] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
const [categoryIconPrevImage,setCategoryIconPrevImage]=useState()
  const [errors, setErrors] = useState({});
  const [categoryDetails, setCategoryDetails] = useState();
  const [removedImages, setRemovedImages] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  useEffect(() => {
    if (categoryId) {
      fetchCategoryDetails(categoryId);
    } else {
      resetForm();
    }
  }, [categoryId, isOpen]);

  const fetchCategoryDetails = async (id) => {
    try {
      setLoader(true);
      const getCategory = await ApiClient.get(`api/category/get-category-by-id/${id}`, "", true,dispatch);
      if (getCategory.status) {
        const categoryData = getCategory.body;
        setCategoryName(categoryData.categoryName);
        setCategoryDescription(categoryData.categoryDescription);
        setVideoLinks(categoryData.videoLink || ['']);
        setCategoryImages(categoryData.categoryImage || []);
        setCategoryPrevImage(categoryData.categoryImageThumbnail || [])
        setCategoryIcon(categoryData.categoryIcon || null);
        setCategoryDetails(categoryData);
        setCategoryIconPrevImage(categoryData?.categoryIconThumbnail?.url);

        setLoader(false);
      } else {
        setLoader(false);
        toast.error(getCategory.message, { autoClose: 3000 });
      }
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };


  const resetForm = () => {
    setCategoryName('');
    setCategoryDescription('');
    setVideoLinks(['']);
    setCategoryImages([]);
    setCategoryPrevImage([])
    setRemovedImages([])
    setCategoryIcon(null);
    setSelectedImages([])
    setCategoryIconPrevImage()
    setErrors({});
  };

  
  const validate = () => {
    const errors = {};
    if (!categoryName) {
      errors.categoryName = "Category name is required";
    }
    if (!categoryDescription) {
      errors.categoryDescription = "Category description is required";
    }
    if ((!selectedImages || selectedImages.length === 0) && (!categoryPrevImage || categoryPrevImage.length === 0)) {
      errors.categoryImages = "Category image is required";
    } else {
      // Check the size of each selected image
      for (let image of selectedImages) {
        if (image.size / 1000000 > 5) { // size is in bytes, so converting to MB
          errors.categoryImages = "File size should not be greater than 5MB";
          break;
        }
      }
    }
    if (!categoryIcon ||  !categoryIconPrevImage) {
      errors.categoryIcon = "Category icon is required";
    } else if(categoryIcon && categoryIcon.size / 1000000 > 5) {
      errors.categoryIcon = "File size should not be greater than 5MB";
    }
    return errors;
  };
  

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      const formData = new FormData();
      formData.append('categoryName', categoryName);
      formData.append('categoryDescription', categoryDescription);
      if(videoLinks?.length === 0){
        formData.append("videoLink",[]);
      }else{
        for (const link of videoLinks) {
          formData.append('videoLink', link);
        }
      } 
      selectedImages.forEach((image, index) => {
        formData.append(`categoryImages`, image);
      });
      if (categoryIcon) {
        formData.append('categoryIcon', categoryIcon);
      }
  
      try {
        setLoader(true);
        let response;
        if (categoryId) {
          formData.append('id', categoryId);
          if (removedImages.length > 0) {
            for (const img of removedImages) {
              // formData.append("removedImages", img);
              removedImages.forEach(image => formData.append("removedImages", image));
            }
          } else {
            formData.append("removedImages", []);
          }
          response = await ApiClient._putFormData("api/category/update-category", formData, true,dispatch);
        } else {
          response = await ApiClient._postFormData("api/category/add-category", formData, true,dispatch);
        }
  
        if (response.status === true) {
          toast.success(response.message, { autoClose: 3000 });
          fetchCategories();
          setCategoryName('');
          setCategoryDescription('');
          setVideoLinks(['']);
          setCategoryImages([]);
          setCategoryPrevImage([])
          setRemovedImages([])
          setSelectedImages([])
  
          setCategoryIcon(null);
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
        setLoader(false);
        toggle();
      } catch (error) {
        console.log(error, "error");
        toast.error(error.message, { autoClose: 3000 });
        setLoader(false);
      }

    }
  };

  const handleAddVideoLink = () => {
    setVideoLinks([...videoLinks, '']);
  };

  const handleRemoveVideoLink = (index) => {
    const newVideoLinks = videoLinks.filter((_, i) => i !== index);
    setVideoLinks(newVideoLinks);
  };

  const handleVideoLinkChange = (index, value) => {
    const newVideoLinks = videoLinks.map((link, i) => (i === index ? value : link));
    setVideoLinks(newVideoLinks);
  };

  // const handleImageIcon = (e) => {
  //   setCategoryIcon(e.target.files[0]);
  //   if (categoryId) {
  //     setRemovedImages([
  //       ...removedImages,
  //       categoryDetails?.categoryIcon?.key,
  //       categoryDetails?.categoryIconThumbnail?.key,
  //     ]);
  //   }
  // };

  const handleImageIcon = (e) => {
    setCategoryIcon(e.target.files[0]);
    setCategoryIconPrevImage(URL.createObjectURL(e.target.files[0]));
    if (categoryId) {
      setRemovedImages([
        ...removedImages,
        categoryDetails?.categoryIcon?.key,
        categoryDetails?.categoryIconThumbnail?.key,
      ]);
    }
  };
  const handleImageSelection = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages([...selectedImages, ...files]);
  };

  
  const handleRemoveImage = (thumbnailKey) => {
    // Find the index of the thumbnail in the articlePrevImage array
    const index = categoryPrevImage.findIndex(image => image.key === thumbnailKey);
  
    // If the index is found
    if (index !== -1) {
      // Get the full-size image key using the same index
      const fullSizeImageKey = categoryImages[index].key;
  
      // Add both keys to the removedImages array
      setRemovedImages([...removedImages, thumbnailKey, fullSizeImageKey]);
  
      // Remove the images from their respective arrays using the index
      const updatedCategoryPrevImage = categoryPrevImage.filter((_, i) => i !== index);
      const updatedCategoryImages = categoryImages.filter((_, i) => i !== index);
    
  
      // Update the state with the new arrays
      setCategoryPrevImage(updatedCategoryPrevImage);
      setCategoryImages(updatedCategoryImages);
    } else {
      console.error('Thumbnail image not found for key:', thumbnailKey);
    }
  };

  const removeImage = (index) => {
    const newImages = selectedImages.filter((_, i) => i !== index);
    setSelectedImages(newImages);
    if (newImages.length === 0) {
      setFileInputKey(Date.now());
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{categoryId ? 'Edit Category' : 'Add Category'}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="categoryName">Category Name</Label>
            <Input
              type="text"
              name="categoryName"
              id="categoryName"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />
            {errors.categoryName && (
              <div className="error-message">{errors.categoryName}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label for="categoryDescription">Category Description</Label>
            <Input
              type="textarea"
              name="categoryDescription"
              id="categoryDescription"
              value={categoryDescription}
              onChange={(e) => setCategoryDescription(e.target.value)}
            />
            {errors.categoryDescription && (
              <div className="error-message">{errors.categoryDescription}</div>
            )}
          </FormGroup>
          <FormGroup>
            <Label>Video Links</Label>
            {videoLinks.map((link, index) => (
              <Row key={index} className="mb-2 align-items-center">
                <Col md={10}>
                  <Input
                    type="text"
                    value={link}
                    onChange={(e) => handleVideoLinkChange(index, e.target.value)}
                  />
                </Col>
                <Col md={2} className="text-right">
                  <Button color="link" onClick={() => handleRemoveVideoLink(index)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                </Col>
              </Row>
            ))}
            <Button color="link" onClick={handleAddVideoLink}>
              <RiAddCircleLine size={24} />
            </Button>
          </FormGroup>
          <FormGroup 
              className='upload_files'
          
          >
            <Label for="categoryImage">Category Images</Label>
            <Input
                  type="file"
                  id="articleImage"
                  key={fileInputKey} // Add the key prop to force re-render
                  name="articleImage"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleImageSelection}  
                  multiple
                />
                {errors.categoryImages && (
                  <div className="error-message">
                    {errors.categoryImages}
                  </div>
                )}
             <div className="d-flex flex-wrap">
                  {categoryPrevImage && categoryPrevImage?.map((image, index) => (
                    <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                      <CardImg
                        alt="Thumbnail"
                        className="img-preview-small"
                        src={image?.url || URL.createObjectURL(image)}
                        top
                      />
                       <Button color="link" size="sm" className="position-absolute custom-remove" onClick={() => handleRemoveImage(image.key)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                    </div>
                  ))}


                    { selectedImages.map((image, index) => (

                      <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                        
                        <CardImg
                         src={image?.url || URL.createObjectURL(image)}
                          className="img-preview-small"
                          alt={`preview-${index}`}
                          style={{ width: '100px' }}
                        />
                    <Button color="link" size="sm" className="position-absolute custom-remove" onClick={() => removeImage(index)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                      </div>
                    ))}
                  </div>
         
          </FormGroup>
          <FormGroup 
           className='upload_files'>
            <Label for="categoryIcon">Category Icon</Label>
            <Input
              type="file"
              name="categoryIcon"
              id="categoryIcon"
              accept=".jpeg, .jpg, .png"
              onChange={handleImageIcon}
            />
            {categoryIconPrevImage && (
              <CardImg
                alt="Thumbnail"
                className="img-preview-small"
                src={categoryIconPrevImage}
                top
              />
            )}
            {errors.categoryIcon && (
              <div className="error-message">{errors.categoryIcon}</div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button className='common-button' onClick={handleSubmit}>
          {categoryId ? "Update Category" : "Add Category"}{" "}
          {loader && <Spinner size="sm"className='ml-2 ' />}
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddCategoryModal;